import React from 'react'

import buildLink from '../../helpers/linkBuilder'
import globalState from '../../helpers/globalState'

import Styles from '../../styles/components/searchInput.module.scss'

const SearchIcon = ({ onClick }) => (
  <svg
    onClick={onClick}
    className={Styles.searchIcon}
    viewBox="0 0 91.685753 91.641876"
  >
    <path d="M 17.235,5e-4 0,17.23425 l 0,24.3725 17.235,17.235 24.3725,0 4.99625,-4.99625 12.26125,12.26125 0,2.26875 23.26625,23.26625 2.2775,0 7.27625,-7.2775 0,-2.2775 -23.265,-23.26625 -2.27,0 -12.26125,-12.2625 4.9525,-4.95125 0,-24.3725 L 41.6075,5e-4 17.235,5e-4 Z m -6.76375,37.26875 0,-15.6975 11.10125,-11.10125 15.69625,0 11.10125,11.10125 0,15.6975 -11.10125,11.1 -15.69625,0 -11.10125,-11.1 z m 12.08,-22.77125 -7.9175,7.91875 0,7.00375 3.665,0 0,-5.48625 5.77,-5.77125 5.3525,0 0,-3.665 -6.87,0 z" />
  </svg>
)

class SearchInput extends React.PureComponent {
  constructor(props) {
    super(props)

    this.search = this.search.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)

    this.state = {
      focus: false,
      query: '',
    }
  }

  search() {
    const searchPath = buildLink({
      slug: 'search',
      type: 'static',
      lang: globalState.state.language,
    })

    const path = `${searchPath}/${encodeURIComponent(this.state.query)}`
    window.___navigateTo(path)
  }

  onFocus() {
    this.setState(state => ({ ...state, focus: true }))
  }

  onBlur() {
    this.setState(state => ({ ...state, focus: false }))
  }

  handleChange(event) {
    this.setState({ ...this.state, query: event.target.value })
  }

  handleKeyPress(event) {
    if (event.charCode === 13) {
      this.search()
    }
  }

  render() {
    const { open } = this.props
    const { focus, query } = this.state

    return (
      <div
        className={open ? Styles.wrapperPositionOpen : Styles.wrapperPosition}
      >
        <div className={focus ? Styles.wrapperFocus : Styles.wrapper}>
          <input
            className={Styles.input}
            type="text"
            value={query}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPress}
          />
          <SearchIcon onClick={this.search} />
        </div>
      </div>
    )
  }
}

export default SearchInput



// WEBPACK FOOTER //
// ./src/components/menu/searchInput.js